export default {
  model: {
    event: "change",
    prop: "field",
  },
  props: {
    field: {
      type: Object,
      default: () => {},
    },
    fields: { type: Array, default: () => [] },
  },
  methods: {
    changeProp() {
      this.$emit("changeProp", this.field);
    },
    on_changed_fields(fields) {
      this.field.fields = fields;
      // Widget Property Change
      console.log(
        `[${new Date().toISOString()}] WidgetPropMixin @change event:`,
        {
          component: "WidgetPropMixin",
          fieldCode: this.field.code,
          fieldType: this.field.field_type,
          fieldsCount: fields.length,
          field: this.field,
        }
      );
      this.$emit("change", this.field);
    },
    on_select(field) {
      this.$emit("select", field);
    },
  },
};
